import type { SubscriptionTier } from '@/entities/subscription';

export const capitalizeTier = (tier: SubscriptionTier): string => tier.charAt(0).toUpperCase() + tier.slice(1);
